import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';

const financialFrames = (state: RootState) =>
  state.financialFrames.financialFrames;
const loading = (state: RootState) => state.financialFrames.loading;
const loaded = (state: RootState) => state.financialFrames.loaded;
const updateLoading = (state: RootState) => state.financialFrames.updateLoading;
const error = (state: RootState) => state.financialFrames.error;
const globalForecast = (state: RootState) =>
  state.financialFrames.globalForecast;
const globalForecastLoading = (state: RootState) =>
  state.financialFrames.globalForecastLoading;
const globalForecastSubmitLoading = (state: RootState) =>
  state.financialFrames.globalForecastSubmitLoading;

const selectFinancialFrames = createDraftSafeSelector(
  financialFrames,
  (financialFrames) => financialFrames || [],
);

const selectFinancialFramesLoading = createDraftSafeSelector(
  loading,
  (loading) => loading,
);

const selectFinancialFramesLoaded = createDraftSafeSelector(
  loaded,
  (loaded) => loaded,
);

const selectFinancialFramesError = createDraftSafeSelector(
  error,
  (error) => error,
);

const selectFinancialFrameUpdateLoading = createDraftSafeSelector(
  updateLoading,
  (updateLoading) => updateLoading,
);

const selectCountryFinancialFrames = createDraftSafeSelector(
  selectFinancialFrames,
  (frames) =>
    frames.filter((frame) => !frame.rowType || frame.rowType === 'COUNTRY'),
);

const selectGlobalFinancialFrames = createDraftSafeSelector(
  selectFinancialFrames,
  (frames) =>
    frames.filter(
      (frame) => frame.rowType === 'GLOBAL' || frame.rowType === 'UNALLOCATED',
    ),
);

const selectGlobalForecast = createDraftSafeSelector(
  globalForecast,
  (globalForecast) => globalForecast,
);

const selectGlobalForecastLoading = createDraftSafeSelector(
  globalForecastLoading,
  (globalForecastLoading) => globalForecastLoading,
);

const selectGlobalForecastSubmitLoading = createDraftSafeSelector(
  globalForecastSubmitLoading,
  (globalForecastSubmitLoading) => globalForecastSubmitLoading,
);

export {
  selectFinancialFrames,
  selectFinancialFramesLoading,
  selectFinancialFramesLoaded,
  selectFinancialFramesError,
  selectFinancialFrameUpdateLoading,
  selectCountryFinancialFrames,
  selectGlobalFinancialFrames,
  selectGlobalForecast,
  selectGlobalForecastLoading,
  selectGlobalForecastSubmitLoading,
};
